<template>
  <section class="o-section o-section--full">
    <div class="o-section__wrapper">
      <div class="o-wrapper">

        <div class="u-align-center o-flex u-padding-bottom c-header-spacing">
          <div>
            <div class="c-logo c-logo--intro" ref="logo">
              <img :src="`/assets/logo_${lang}.${extension}`" :alt="`Logo ${globals.title}`">
            </div>
          </div>

          <div class="u-margin-top u-h1" v-if="progress < 100">{{ progress }}%</div>

          <div v-if="!isDesktop && progress === 100">
            <figure class="e-img--intro u-margin-top" ref="figureA">
              <Img :src="require('@/assets/intro/intro_a2.png')" filename="intro_a2" />
            </figure>
          </div>

          <div :class="{
            'e-page--intro u-margin-top u-8/12@desktop u-push-2/12@desktop u-6/12@wide u-push-3/12@wide': true,
            'is-visible': progress === 100
          }">
            <p v-html="translations.text"></p>

              <div class="u-margin-top" ref="cta">
                <a class="u-h2 e-link--cta" href="#" @click.prevent="scrollDown">
                  {{ translations.cta }}

                  <img src="/assets/arrow_down.svg" alt="Icon Arrow Down">
                </a>
              </div>
          </div>
        </div>

      </div>

      <div class="o-section__figure-wrapper is-center-center" v-show="isDesktop">
        <figure style="opacity:0;" class="o-section__figure" ref="figureD">
          <Img :src="require('@/assets/intro/intro_d.png')" filename="intro_d" />
        </figure>

        <figure style="opacity:0;" class="o-section__figure" ref="figureE">
          <Img :src="require('@/assets/intro/intro_e.png')" filename="intro_e" />
        </figure>

        <figure style="opacity:0;" class="o-section__figure" ref="figureA">
          <Img :src="require('@/assets/intro/intro_a.png')" filename="intro_a" />
        </figure>

        <figure style="opacity:0;" class="o-section__figure" ref="figureB">
          <Img :src="require('@/assets/intro/intro_b.png')" filename="intro_b" />
        </figure>

        <figure style="opacity:0;" class="o-section__figure" ref="figureC">
          <Img :src="require('@/assets/intro/intro_c.png')" filename="intro_c" />
        </figure>
      </div>

    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Img from '@/components/Img'

export default {
  name: 'Intro',
  props: ['options', 'active', 'progress', 'disableBlur', 'isDesktop'],

  mounted () {
    this.$root.$on('startScene0', () => {
      this.init()
    })
  },

  methods: {
    scrollDown () {
      this.$root.$emit('scrollDown')
    },

    init () {
      this.$anime({
        targets: [this.$refs.figureA, this.$refs.figureB, this.$refs.figureC, this.$refs.figureD, this.$refs.figureE],
        opacity: [0, 1],
        duration: this.options.durationSmall,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureB,
        translateX: ['-20px', '0'],
        duration: this.options.durationRegular,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.cta,
        opacity: [0, 1],
        translateY: ['20px', '0'],
        delay: 1000,
        duration: this.options.durationSmall,
        easing: this.options.easing
      })

      setInterval(() => {
        this.$anime({
          targets: this.$refs.cta.querySelector('img'),
          translateY: ['0px', '5px'],
          loop: 1,
          direction: 'alternate',
          duration: 300,
          easing: this.options.easing
        })
      }, 1500)

      this.$anime({
        targets: this.$refs.figureC,
        translateX: ['40px', '0'],
        duration: this.options.durationRegular,
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: this.$refs.figureD,
          translateX: ['20px', '0'],
          opacity: [0, 1],
          delay: 200,
          duration: this.options.durationLarge,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureE,
          translateX: ['-40px', '0'],
          opacity: [0, 1],
          delay: 200,
          duration: this.options.durationLarge,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: this.$refs.figureD,
          translateX: ['20px', '0'],
          filter: ['blur(5px)', 'blur(0px)'],
          duration: this.options.durationLarge,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureE,
          translateX: ['-40px', '0'],
          filter: ['blur(5px)', 'blur(0px)'],
          duration: this.options.durationLarge,
          easing: this.options.easing
        })
      }

      this.$anime({
        targets: this.$refs.figureA,
        translateX: ['40px', '0'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })
    }
  },

  computed: mapState({
    lang: state => state.language,
    webP: state => state.webp,
    translations (state) {
      const lang = this.lang
      return state.translations.intro[lang]
    },
    globals (state) {
      const lang = this.lang
      return state.translations.general[lang]
    },
    extension () {
      return this.webP ? 'webp' : 'png'
    }
  }),

  components: {
    Img
  }
}
</script>
